import styled from 'styled-components';
import { DisplayFieldRowStyled } from 'components/forms/displayField/DisplayField.styles';

export const FieldsetStyled = styled.fieldset`
  ${DisplayFieldRowStyled} {
    margin-left: 0;
    margin-right: 0;

    label {
      text-align: right;
    }
  }
`;
